import React, { useState, useEffect } from 'react';
import { ThemeProvider } from 'styled-components'
import { lightTheme, darkTheme, GlobalStyles } from '../themes.js'
import { Link } from 'react-router-dom';
import './styles/insurance.scss'
import lobInsurance from '../assets/img/lob-insu.png'
import BackToTopButton from '../component/back-to-top.js';
import emailjs from 'emailjs-com';
import TextField from '@mui/material/TextField';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Alert from '@mui/material/Alert';

import articleInsurance from '../data/articleInsurance.json'

function Insurance(themeData) {

  useEffect(() => {
    document.title = 'Insurance Management Consulting • Miravite Consulting Group';
  }, []);

  // Function to convert headline to kebab case
  const toKebabCase = (str) =>
    str &&
    str
      .match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|[A-Z]*$)|[A-Z]?[a-z]+[0-9]*|[0-9]+/g)
      .map((x) => x.toLowerCase())
      .join('-');

  const [showAllInsuranceRelatedArticles, setShowAllInsuranceRelatedArticles] = useState(false);

  // Function to check if the stored timestamp is within the last 10 minutes
  const isTimestampValid = (timestamp) => {
    const tenMinutes = 10 * 60 * 1000; // 10 minutes in milliseconds
    const currentTime = new Date().getTime();
    // console.log(`Current Time: ${currentTime}, Saved Time: ${timestamp}`);
    // console.log(`Difference: ${currentTime - timestamp}, Valid: ${currentTime - timestamp < tenMinutes}`);
    return currentTime - timestamp < tenMinutes;
  };

  // Initialize state from local storage
  useEffect(() => {
    const checkDataValidity = () => {
      const savedData = localStorage.getItem('showAllInsuranceRelatedArticlesData');
      if (savedData) {
        const parsedData = JSON.parse(savedData);
        if (isTimestampValid(parsedData.timestamp)) {
          setShowAllInsuranceRelatedArticles(parsedData.showAllInsuranceRelatedArticles);
        } else {
          // Data is expired, remove from local storage
          localStorage.removeItem('showAllInsuranceRelatedArticlesData');
          setShowAllInsuranceRelatedArticles(false);
        }
      }
    };
  
    checkDataValidity(); // Initial check on component mount
  
    const interval = setInterval(checkDataValidity, 60000); // Check every 1 minute
  
    return () => clearInterval(interval); // Cleanup on unmount
  }, []);

  // Update local storage whenever 'showAllInsuranceRelatedArticles' changes
  useEffect(() => {
    if (showAllInsuranceRelatedArticles) {
      const dataToStore = {
        showAllInsuranceRelatedArticles: showAllInsuranceRelatedArticles,
        timestamp: new Date().getTime(),
      };
      localStorage.setItem('showAllInsuranceRelatedArticlesData', JSON.stringify(dataToStore));
    } else {
      localStorage.removeItem('showAllInsuranceRelatedArticlesData');
    }
  }, [showAllInsuranceRelatedArticles]);

  const [formData, setFormData] = useState({
    lineOfBusiness: 'Insurance Management Consulting',
    addresseeName: '',
    addresseeDesignation: '',
    companyName: '',
    companyAddress: '',
    employeeCount: '',
    fiscalYearEnd: '',
    actuarialProvider: '',
    retirementPlanType: '',
    contactNumber: '',
    emailAddress: '',
    message: '',
    dcAdmin: '',
    onlineManual: '',
    isPensionForm: 'yes'
  });

  const [resultMessage, setResultMessage] = useState('');
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === 'checkbox' ? checked : value,
    }));
  
    // Remove the error key for the field
    if (errors[name]) {
      setErrors((prevErrors) => {
        const newErrors = { ...prevErrors };
        delete newErrors[name];
        return newErrors;
      });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

     // Initialize an empty errors object
    let tempErrors = {};

    // Validate each required field individually

    if (!formData.addresseeName) {
      tempErrors.addresseeName = 'This field is required.';
    }

    // if (!formData.addresseeDesignation) {
    //   tempErrors.addresseeDesignation = 'This field is required.';
    // }

    if (!formData.companyName) {
      tempErrors.companyName = 'This field is required.';
    }

    // if (!formData.companyAddress) {
    //   tempErrors.companyAddress = 'This field is required.';
    // }

    // if (!formData.employeeCount) {
    //   tempErrors.employeeCount = 'This field is required.';
    // }

    // if (!formData.fiscalYearEnd) {
    //   tempErrors.fiscalYearEnd = 'This field is required.';
    // }

    // if (!formData.actuarialProvider) {
    //   tempErrors.actuarialProvider = 'This field is required.';
    // }

    // if (!formData.retirementPlanType) {
    //   tempErrors.retirementPlanType = 'This field is required.';
    // }

    // if (!formData.contactNumber) {
    //   tempErrors.contactNumber = 'This field is required.';
    // }

    if (!formData.emailAddress) {
      tempErrors.emailAddress = 'This field is required.';
    }

    // if (!formData.message) {
    //   tempErrors.message = 'This field is required.';
    // }

    // Update the errors state
    setErrors(tempErrors);

    // If there are errors, do not proceed
    if (Object.keys(tempErrors).length > 0) {
      return;
    }

    emailjs.send(
      process.env.REACT_APP_EMAILJS_SERVICE_ID,
      process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
      // e.target, 
      formData,
      process.env.REACT_APP_EMAILJS_USER_ID
    )
    .then((response) => {
      // console.log('SUCCESS!', response.status, response.text);
      setResultMessage('Your message has been sent successfully!');
      setSuccess(true); 
      setFormData({
        lineOfBusiness: 'Insurance Management Consulting',
        addresseeName: '',
        addresseeDesignation: '',
        companyName: '',
        companyAddress: '',
        employeeCount: '',
        fiscalYearEnd: '',
        actuarialProvider: '',
        retirementPlanType: '',
        contactNumber: '',
        emailAddress: '',
        message: '',
      });
      setErrors({}); // Clear errors after successful submission
      // console.log('FORM DATAAAAAAA',formData)
    })
    .catch((err) => {
      console.error('FAILED...', err);
      setResultMessage('An error occurred. Please try again.');
    });
  };

  const [success, setSuccess] = useState(false);

  return (

    <ThemeProvider theme={themeData.theme === 'light' ? lightTheme : darkTheme}>
    <GlobalStyles />
    <BackToTopButton />


      <div id='insurance'>

        <header>
          <div className='banner-img'>
            <img src={lobInsurance} />
          </div>
          <div className='banner-overlay'>
            <div className='banner-wrapper'>
              <div className='banner-title'>Insurance Management Consulting</div>
              <div className='banner-subtitle'>Work with the best insurance and actuarial subject-matter experts in the Philippines.</div>
            </div>
          </div>
        </header>

        <section className="insurance">
            <div className='insurance-container'>
              <span className='insurance-title'>We provide end-to-end solutions and advisory services to all insurance companies.</span>

              
              <div className='e2e-container'>
                <div className='each-e2e life'>
                  <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10.95 12.6999L9.55 11.2999C9.35 11.0999 9.11667 10.9999 8.85 10.9999C8.58333 10.9999 8.35 11.0999 8.15 11.2999C7.95 11.4999 7.85 11.7374 7.85 12.0124C7.85 12.2874 7.95 12.5249 8.15 12.7249L10.25 14.8499C10.45 15.0499 10.6833 15.1499 10.95 15.1499C11.2167 15.1499 11.45 15.0499 11.65 14.8499L15.9 10.5999C16.1 10.3999 16.2 10.1624 16.2 9.8874C16.2 9.6124 16.1 9.3749 15.9 9.1749C15.7 8.9749 15.4625 8.8749 15.1875 8.8749C14.9125 8.8749 14.675 8.9749 14.475 9.1749L10.95 12.6999ZM12 21.8999C11.8833 21.8999 11.775 21.8916 11.675 21.8749C11.575 21.8582 11.475 21.8332 11.375 21.7999C9.125 21.0499 7.33333 19.6624 6 17.6374C4.66667 15.6124 4 13.4332 4 11.0999V6.3749C4 5.95824 4.12083 5.58324 4.3625 5.2499C4.60417 4.91657 4.91667 4.6749 5.3 4.5249L11.3 2.2749C11.5333 2.19157 11.7667 2.1499 12 2.1499C12.2333 2.1499 12.4667 2.19157 12.7 2.2749L18.7 4.5249C19.0833 4.6749 19.3958 4.91657 19.6375 5.2499C19.8792 5.58324 20 5.95824 20 6.3749V11.0999C20 13.4332 19.3333 15.6124 18 17.6374C16.6667 19.6624 14.875 21.0499 12.625 21.7999C12.525 21.8332 12.425 21.8582 12.325 21.8749C12.225 21.8916 12.1167 21.8999 12 21.8999ZM12 19.8999C13.7333 19.3499 15.1667 18.2499 16.3 16.5999C17.4333 14.9499 18 13.1166 18 11.0999V6.3749L12 4.1249L6 6.3749V11.0999C6 13.1166 6.56667 14.9499 7.7 16.5999C8.83333 18.2499 10.2667 19.3499 12 19.8999Z" fill="white"/>
                  </svg>
                  <span>Life Insurance</span>
                </div>
                <div className='each-e2e non-life'>
                  <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M6 19V19.5C6 19.9167 5.85417 20.2708 5.5625 20.5625C5.27083 20.8542 4.91667 21 4.5 21C4.08333 21 3.72917 20.8542 3.4375 20.5625C3.14583 20.2708 3 19.9167 3 19.5V12.35C3 12.2333 3.00833 12.1167 3.025 12C3.04167 11.8833 3.06667 11.775 3.1 11.675L4.975 6.35C5.10833 5.95 5.35 5.625 5.7 5.375C6.05 5.125 6.44167 5 6.875 5H17.125C17.5583 5 17.95 5.125 18.3 5.375C18.65 5.625 18.8917 5.95 19.025 6.35L20.9 11.675C20.9333 11.775 20.9583 11.8833 20.975 12C20.9917 12.1167 21 12.2333 21 12.35V19.5C21 19.9167 20.8542 20.2708 20.5625 20.5625C20.2708 20.8542 19.9167 21 19.5 21C19.0833 21 18.7292 20.8542 18.4375 20.5625C18.1458 20.2708 18 19.9167 18 19.5V19H6ZM5.8 10H18.2L17.15 7H6.85L5.8 10ZM7.5 16C7.91667 16 8.27083 15.8542 8.5625 15.5625C8.85417 15.2708 9 14.9167 9 14.5C9 14.0833 8.85417 13.7292 8.5625 13.4375C8.27083 13.1458 7.91667 13 7.5 13C7.08333 13 6.72917 13.1458 6.4375 13.4375C6.14583 13.7292 6 14.0833 6 14.5C6 14.9167 6.14583 15.2708 6.4375 15.5625C6.72917 15.8542 7.08333 16 7.5 16ZM16.5 16C16.9167 16 17.2708 15.8542 17.5625 15.5625C17.8542 15.2708 18 14.9167 18 14.5C18 14.0833 17.8542 13.7292 17.5625 13.4375C17.2708 13.1458 16.9167 13 16.5 13C16.0833 13 15.7292 13.1458 15.4375 13.4375C15.1458 13.7292 15 14.0833 15 14.5C15 14.9167 15.1458 15.2708 15.4375 15.5625C15.7292 15.8542 16.0833 16 16.5 16ZM5 17H19V12H5V17Z" fill="white"/>
                  </svg>
                  <span>Non-Life Insurance</span>
                </div>
                <div className='each-e2e hmo'>
                  <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10.5 12.9999V14.4999C10.5 14.7832 10.5958 15.0207 10.7875 15.2124C10.9792 15.4041 11.2167 15.4999 11.5 15.4999H12.5C12.7833 15.4999 13.0208 15.4041 13.2125 15.2124C13.4042 15.0207 13.5 14.7832 13.5 14.4999V12.9999H15C15.2833 12.9999 15.5208 12.9041 15.7125 12.7124C15.9042 12.5207 16 12.2832 16 11.9999V10.9999C16 10.7166 15.9042 10.4791 15.7125 10.2874C15.5208 10.0957 15.2833 9.9999 15 9.9999H13.5V8.4999C13.5 8.21657 13.4042 7.97907 13.2125 7.7874C13.0208 7.59574 12.7833 7.4999 12.5 7.4999H11.5C11.2167 7.4999 10.9792 7.59574 10.7875 7.7874C10.5958 7.97907 10.5 8.21657 10.5 8.4999V9.9999H9C8.71667 9.9999 8.47917 10.0957 8.2875 10.2874C8.09583 10.4791 8 10.7166 8 10.9999V11.9999C8 12.2832 8.09583 12.5207 8.2875 12.7124C8.47917 12.9041 8.71667 12.9999 9 12.9999H10.5ZM12 21.8999C11.8833 21.8999 11.775 21.8916 11.675 21.8749C11.575 21.8582 11.475 21.8332 11.375 21.7999C9.125 21.0499 7.33333 19.6624 6 17.6374C4.66667 15.6124 4 13.4332 4 11.0999V6.3749C4 5.95824 4.12083 5.58324 4.3625 5.2499C4.60417 4.91657 4.91667 4.6749 5.3 4.5249L11.3 2.2749C11.5333 2.19157 11.7667 2.1499 12 2.1499C12.2333 2.1499 12.4667 2.19157 12.7 2.2749L18.7 4.5249C19.0833 4.6749 19.3958 4.91657 19.6375 5.2499C19.8792 5.58324 20 5.95824 20 6.3749V11.0999C20 13.4332 19.3333 15.6124 18 17.6374C16.6667 19.6624 14.875 21.0499 12.625 21.7999C12.525 21.8332 12.425 21.8582 12.325 21.8749C12.225 21.8916 12.1167 21.8999 12 21.8999ZM12 19.8999C13.7333 19.3499 15.1667 18.2499 16.3 16.5999C17.4333 14.9499 18 13.1166 18 11.0999V6.3749L12 4.1249L6 6.3749V11.0999C6 13.1166 6.56667 14.9499 7.7 16.5999C8.83333 18.2499 10.2667 19.3499 12 19.8999Z" fill="white"/>
                  </svg>
                  <span>HMO</span>
                </div>
                <div className='each-e2e pre-need'>
                  <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1 19V16C1 15.4333 1.19583 14.9583 1.5875 14.575C1.97917 14.1917 2.45 14 3 14H6.275C6.60833 14 6.925 14.0833 7.225 14.25C7.525 14.4167 7.76667 14.6417 7.95 14.925C8.43333 15.575 9.02917 16.0833 9.7375 16.45C10.4458 16.8167 11.2 17 12 17C12.8167 17 13.5792 16.8167 14.2875 16.45C14.9958 16.0833 15.5833 15.575 16.05 14.925C16.2667 14.6417 16.5208 14.4167 16.8125 14.25C17.1042 14.0833 17.4083 14 17.725 14H21C21.5667 14 22.0417 14.1917 22.425 14.575C22.8083 14.9583 23 15.4333 23 16V19C23 19.2833 22.9042 19.5208 22.7125 19.7125C22.5208 19.9042 22.2833 20 22 20H17C16.7167 20 16.4792 19.9042 16.2875 19.7125C16.0958 19.5208 16 19.2833 16 19V17.725C15.4167 18.1417 14.7875 18.4583 14.1125 18.675C13.4375 18.8917 12.7333 19 12 19C11.2833 19 10.5833 18.8875 9.9 18.6625C9.21667 18.4375 8.58333 18.1167 8 17.7V19C8 19.2833 7.90417 19.5208 7.7125 19.7125C7.52083 19.9042 7.28333 20 7 20H2C1.71667 20 1.47917 19.9042 1.2875 19.7125C1.09583 19.5208 1 19.2833 1 19ZM12 16C11.3667 16 10.7667 15.8542 10.2 15.5625C9.63333 15.2708 9.15833 14.8667 8.775 14.35C8.49167 13.9333 8.1375 13.6042 7.7125 13.3625C7.2875 13.1208 6.825 13 6.325 13C6.69167 12.3833 7.46667 11.8958 8.65 11.5375C9.83333 11.1792 10.95 11 12 11C13.05 11 14.1667 11.1792 15.35 11.5375C16.5333 11.8958 17.3083 12.3833 17.675 13C17.1917 13 16.7333 13.1208 16.3 13.3625C15.8667 13.6042 15.5083 13.9333 15.225 14.35C14.8583 14.8833 14.3917 15.2917 13.825 15.575C13.2583 15.8583 12.65 16 12 16ZM4 13C3.16667 13 2.45833 12.7083 1.875 12.125C1.29167 11.5417 1 10.8333 1 10C1 9.15 1.29167 8.4375 1.875 7.8625C2.45833 7.2875 3.16667 7 4 7C4.85 7 5.5625 7.2875 6.1375 7.8625C6.7125 8.4375 7 9.15 7 10C7 10.8333 6.7125 11.5417 6.1375 12.125C5.5625 12.7083 4.85 13 4 13ZM20 13C19.1667 13 18.4583 12.7083 17.875 12.125C17.2917 11.5417 17 10.8333 17 10C17 9.15 17.2917 8.4375 17.875 7.8625C18.4583 7.2875 19.1667 7 20 7C20.85 7 21.5625 7.2875 22.1375 7.8625C22.7125 8.4375 23 9.15 23 10C23 10.8333 22.7125 11.5417 22.1375 12.125C21.5625 12.7083 20.85 13 20 13ZM12 10C11.1667 10 10.4583 9.70833 9.875 9.125C9.29167 8.54167 9 7.83333 9 7C9 6.15 9.29167 5.4375 9.875 4.8625C10.4583 4.2875 11.1667 4 12 4C12.85 4 13.5625 4.2875 14.1375 4.8625C14.7125 5.4375 15 6.15 15 7C15 7.83333 14.7125 8.54167 14.1375 9.125C13.5625 9.70833 12.85 10 12 10Z" fill="white"/>
                  </svg>
                  <span>MBA</span>
                </div>
                <div className='each-e2e social'>
                  <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5 16V11C5 10.7167 5.09583 10.4792 5.2875 10.2875C5.47917 10.0958 5.71667 10 6 10C6.28333 10 6.52083 10.0958 6.7125 10.2875C6.90417 10.4792 7 10.7167 7 11V16C7 16.2833 6.90417 16.5208 6.7125 16.7125C6.52083 16.9042 6.28333 17 6 17C5.71667 17 5.47917 16.9042 5.2875 16.7125C5.09583 16.5208 5 16.2833 5 16ZM11 16V11C11 10.7167 11.0958 10.4792 11.2875 10.2875C11.4792 10.0958 11.7167 10 12 10C12.2833 10 12.5208 10.0958 12.7125 10.2875C12.9042 10.4792 13 10.7167 13 11V16C13 16.2833 12.9042 16.5208 12.7125 16.7125C12.5208 16.9042 12.2833 17 12 17C11.7167 17 11.4792 16.9042 11.2875 16.7125C11.0958 16.5208 11 16.2833 11 16ZM3 21C2.71667 21 2.47917 20.9042 2.2875 20.7125C2.09583 20.5208 2 20.2833 2 20C2 19.7167 2.09583 19.4792 2.2875 19.2875C2.47917 19.0958 2.71667 19 3 19H21C21.2833 19 21.5208 19.0958 21.7125 19.2875C21.9042 19.4792 22 19.7167 22 20C22 20.2833 21.9042 20.5208 21.7125 20.7125C21.5208 20.9042 21.2833 21 21 21H3ZM17 16V11C17 10.7167 17.0958 10.4792 17.2875 10.2875C17.4792 10.0958 17.7167 10 18 10C18.2833 10 18.5208 10.0958 18.7125 10.2875C18.9042 10.4792 19 10.7167 19 11V16C19 16.2833 18.9042 16.5208 18.7125 16.7125C18.5208 16.9042 18.2833 17 18 17C17.7167 17 17.4792 16.9042 17.2875 16.7125C17.0958 16.5208 17 16.2833 17 16ZM21 8H2.9C2.65 8 2.4375 7.9125 2.2625 7.7375C2.0875 7.5625 2 7.35 2 7.1V6.55C2 6.36667 2.04583 6.20833 2.1375 6.075C2.22917 5.94167 2.35 5.83333 2.5 5.75L11.1 1.45C11.3833 1.31667 11.6833 1.25 12 1.25C12.3167 1.25 12.6167 1.31667 12.9 1.45L21.45 5.725C21.6333 5.80833 21.7708 5.93333 21.8625 6.1C21.9542 6.26667 22 6.44167 22 6.625V7C22 7.28333 21.9042 7.52083 21.7125 7.7125C21.5208 7.90417 21.2833 8 21 8ZM6.45 6H17.55L12 3.25L6.45 6Z" fill="white"/>
                  </svg>
                  <span>Social Insurance</span>
                </div>
              </div>

              <div className='e2e-list-container'>
                <div className='e2e-row'>
                  <div className='each-in-row'>
                    <div className='adj-bar'>
                      <div className='bar'></div>
                      <div className='content'>
                        <span className='e2e-title'>IFRS17</span>
                        <span className='e2e-list'>
                          <ul>
                            <li>End-to-End Transition & Implementation</li>
                            <li>In-House Sub-Ledger Solution</li>
                            <li>Accounting & Actuarial Policy Papers</li>
                            <li>ETL Processing</li>
                            <li>Internal Financial Audit</li>
                          </ul>
                        </span>
                      </div>
                    </div>
                    <div className='adj-bar'>
                      <div className='bar'></div>
                      <div className='content'>
                        <span className='e2e-title'>Mergers & Acquisition</span>
                        <span className='e2e-list'>
                          <ul>
                            <li>Actuarial Appraisal Value</li>
                            <li>Actuarial Due Diligence</li>
                          </ul>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className='each-in-row'>
                    <div className='adj-bar'>
                      <div className='bar'></div>
                      <div className='content'>
                        <span className='e2e-title'>Actuarial Certification</span>
                        <span className='e2e-list'>
                          <ul>
                            <li>Life Insurance Gross Premium Valuation (GPV)</li>
                            <li>Non-Life Insurance Policy Reserves</li>
                            <li>HMO Agreement Liabilities</li>
                            <li>Actuarial Audit</li>
                          </ul>
                        </span>
                      </div>
                    </div>
                    <div className='adj-bar'>
                      <div className='bar'></div>
                      <div className='content'>
                        <span className='e2e-title'>Special Projects</span>
                        <span className='e2e-list'>
                          <ul>
                            <li>Profitability Management Advisory</li>
                            <li>Product Development & Pricing</li>
                            <li>Risk-Based Capital (RBC) Remediation</li>
                          </ul>
                        </span>
                      </div>
                    </div>
                    {/* <div className='adj-bar'>
                      <div className='bar'></div>
                      <div className='content'>
                        <span className='e2e-title'>Actuarial Audit</span>
                        <span className='e2e-list'>
                          <ul>
                            <li>Actuarial Disclosures</li>
                            <li>Financial Models</li>
                            <li>Internal Reasonability Tests</li>
                            <li>Second Opinion / Recalculation of Reserves</li>
                          </ul>
                        </span>
                      </div>
                    </div> */}
                    {/* <div className='adj-bar'>
                      <div className='bar'></div>
                      <div className='content'>
                        <span className='e2e-title'>Economic Valuation</span>
                        <span className='e2e-list'>
                          <ul>
                            <li>Embedded Value (EV)</li>
                            <li>Actuarial Appraisal Value (AAV)</li>
                            <li>Value of In-Force Business (VIF)</li>
                            <li>Value of New Business (VNB)</li>
                          </ul>
                        </span>
                      </div>
                    </div> */}
                  </div>
                </div>
              </div>

              <div className='proposal-container'>
                <div className='prop-title'>
                  <span className='proposal'>Request for Proposal</span>
                </div>
                <div className='prop-body'>

                <form onSubmit={handleSubmit}>
                      <div className='two-cols'>
                        <TextField
                          className='each-input'
                          id="outlined-basic"
                          label="Name"
                          variant="outlined"
                          value={formData.addresseeName}
                          onChange={handleChange} name="addresseeName"
                          error={!!errors.addresseeName}
                          helperText={errors.addresseeName} />
                        <TextField
                          className='each-input'
                          id="outlined-basic"
                          label="Designation"
                          variant="outlined"
                          value={formData.addresseeDesignation}
                          onChange={handleChange}
                          name="addresseeDesignation"
                          error={!!errors.addresseeDesignation}
                          helperText={errors.addresseeDesignation} />
                      </div>
                      <div className='two-cols'>
                        <TextField
                          className='each-input'
                          id="outlined-basic"
                          label="Company Name"
                          variant="outlined"
                          value={formData.companyName}
                          onChange={handleChange}
                          name="companyName"
                          error={!!errors.companyName} helperText={errors.companyName} />
                        <TextField
                          className='each-input'
                          id="outlined-basic"
                          label="Company Address"
                          variant="outlined"
                          value={formData.companyAddress}
                          onChange={handleChange}
                          name="companyAddress"
                          error={!!errors.companyAddress}
                          helperText={errors.companyAddress} />
                      </div>
                      {/* <div className='two-cols'>
                        <TextField
                          className='each-input'
                          id="outlined-basic"
                          label="Employee Count"
                          variant="outlined"
                          value={formData.employeeCount}
                          onChange={handleChange}
                          name="employeeCount"
                          error={!!errors.employeeCount}
                          helperText={errors.employeeCount} />
                        <TextField className='each-input'
                          id="outlined-basic"
                          label="Calendar / Fiscal Year-End"
                          variant="outlined"
                          value={formData.fiscalYearEnd}
                          onChange={handleChange}
                          name="fiscalYearEnd"
                          error={!!errors.fiscalYearEnd}
                          helperText={errors.fiscalYearEnd} />
                      </div> */}
                      {/* <div className='two-cols'>
                        <TextField
                          className='each-input'
                          id="outlined-basic"
                          label="Previous Actuarial Provider"
                          variant="outlined"
                          value={formData.actuarialProvider}
                          onChange={handleChange}
                          name="actuarialProvider"
                          error={!!errors.actuarialProvider}
                          helperText={errors.actuarialProvider} />
                        <TextField
                          className='each-input'
                          id="outlined-basic" l
                          label="Type of Retirement Plan (DB, DC, None)"
                          variant="outlined"
                          value={formData.retirementPlanType}
                          onChange={handleChange}
                          name="retirementPlanType"
                          error={!!errors.retirementPlanType}
                          helperText={errors.retirementPlanType} />
                      </div> */}
                      <div className='two-cols'>
                       
                        <TextField
                          className='each-input'
                          id="outlined-basic"
                          label="Email Address"
                          variant="outlined"
                          value={formData.emailAddress}
                          onChange={handleChange}
                          name="emailAddress"
                          error={!!errors.emailAddress}
                          helperText={errors.emailAddress} />
                           <TextField
                          className='each-input'
                          id="outlined-basic"
                          label="Contact Number"
                          variant="outlined"
                          value={formData.contactNumber}
                          onChange={handleChange}
                          name="contactNumber"
                          error={!!errors.contactNumber}
                          helperText={errors.contactNumber} />
                      </div>
                      <div className='message'>
                        <TextField
                          multiline
                          rows={4}
                          className='each-input'
                          id="outlined-basic"
                          label="Message"
                          ariant="outlined"
                          value={formData.message}
                          onChange={handleChange}
                          name="message"
                          error={!!errors.message}
                          helperText={errors.message} />
                      </div>
                      <div className='alert'>
                        {success && (
                          <Alert severity="success" style={{ marginTop: '1em' }}>
                            Your message has been sent successfully!
                          </Alert>
                        )}
                      </div>

                      <div className='two-cols'>
                        <div className='blank'></div>
                        <button className='send-form' type='submit'> Submit </button>
                      </div>
                    </form>
                </div>
              </div>

              <span id='related-article'></span>
              <div className='related-articles-container'>
                <span className='related-articles'>Related Articles</span>
              </div>

              <div className='articles-container'>
                {articleInsurance
                  .slice(0, showAllInsuranceRelatedArticles ? articleInsurance.length : 3)
                  .map((article, index) => (
                    <Link 
                      to={`/read/insurance-article/${toKebabCase(article.headline)}`}
                      style={{ textDecoration: 'none', color: 'inherit' }} 
                      key={index} // Add a unique key for each item
                    >
                      <div className='each-article'>
                        <div className='article-banner-container'>
                          <img src={`img/assets/insurance/${article.img}`} alt={article.headline} />
                        </div>
                        <div className='article-contents'>
                          <span className='article-date'>{article.date}</span>
                          <span className='article-headline'>{article.headline}</span>
                          <span className='article-body'>
                            {`${article.body[0]} ${article.body[1]}`.substring(0, 250)}...
                          </span>
                        </div>
                      </div>
                    </Link>
                  ))}
              </div>
              {!showAllInsuranceRelatedArticles && (
                <div className='show-all-container'>
                  <span className='show-all' onClick={() => setShowAllInsuranceRelatedArticles(true)}>Show All</span>
                </div>
              )}

            </div>
        </section>
      </div>
    </ThemeProvider>
  );
};

export default Insurance;